module.exports = __webpack_public_path__ + "static/media/facebook.abfcfeef.svg";